import { render } from "./QuestionFlash.vue?vue&type=template&id=9f077894"
import script from "./QuestionFlash.vue?vue&type=script&lang=js"
export * from "./QuestionFlash.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__